import React from 'react';
import * as S from './Field.style';

export default function Field({ label, name }) {

  return (
    <S.FieldCallError name={name}>{label}</S.FieldCallError>
  );
}
